/**
 * ツリー構造のオブジェクトを対象のキーで平坦化
 *
 * @param {Array} tree - ツリー構造の配列
 * @param {string} key - 収集対象のプロパティ名
 * @returns {Set} 平坦化されたValueのSet
 */
export function collectCodes(tree, key) {
  const set = new Set()

  function dfs(node) {
    if (node[key] !== undefined) {
      set.add(node[key])
    }

    if (node.children) {
      node.children.forEach(child => dfs(child))
    }
  }

  tree.forEach(root => dfs(root))
  return set
}

/**
 * オブジェクトを再帰的に走査し、
 * 指定したキーを含むプロパティのパスを収集する
 * (ListではなくObject型に対する処理なので、ここにおいてよいものか…)
 *
 * @param {Object} obj - 走査対象オブジェクト
 * @param {string} searchKey - 検索対象のプロパティ名
 * @returns {set} 検索対象キーのパスを Set で返す
 */
export function findKeyPaths(obj, searchKey) {
  const result = new Set()

  function dfs(node, path) {
    // nodeがobjじゃないなら返す
    if (node === null || typeof node !== 'object') return
    // nodeに対象のキーがあればpathを入れる
    if (Object.prototype.hasOwnProperty.call(node, searchKey)) {
      result.add(path ? `${path}.${searchKey}` : searchKey)
    }
    // nodeの中にあるか回す
    Object.entries(node).forEach(([key, value]) => {
      const newPath = path ? `${path}.${key}` : key
      dfs(value, newPath)
    })
  }

  dfs(obj, '')
  return result
}
